import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "name"
};
var _hoisted_2 = {
  key: 0,
  class: "edit-h5-header"
};
var _hoisted_3 = {
  class: "left"
};
var _hoisted_4 = {
  class: "input-box"
};
var _hoisted_5 = {
  key: 1
};
var _hoisted_6 = {
  key: 1,
  class: "edit-h5-footer"
};
import { watchEffect, ref, nextTick, watch } from '../../../adapter-vue';
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import Icon from '../../common/Icon.vue';
import editIcon from '../../../assets/icon/edit.svg';
import { Toast, TOAST_TYPE } from '../../common/Toast/index';
import { isPC } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'manage-name',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    isAuthor: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var groupProfile = ref({});
    var inputGroupName = ref('');
    var isEdit = ref(false);
    var nameInputRef = ref(null);
    watchEffect(() => {
      groupProfile.value = props.data;
    });
    var emit = __emit;
    var updateProfile = () => {
      if (!inputGroupName.value) {
        Toast({
          message: TUITranslateService.t('TUIGroup.群名称不能为空'),
          type: TOAST_TYPE.ERROR
        });
      } else {
        if (inputGroupName.value !== groupProfile.value.name) {
          emit('update', {
            key: 'name',
            value: inputGroupName.value
          });
          groupProfile.value.name = inputGroupName.value;
          inputGroupName.value = '';
          Toast({
            message: TUITranslateService.t('TUIGroup.群名称修改成功'),
            type: TOAST_TYPE.SUCCESS
          });
        }
        close();
      }
    };
    var close = () => {
      if (props.isAuthor) {
        isEdit.value = !isEdit.value;
      }
      if (isEdit.value) {
        inputGroupName.value = groupProfile.value.name;
      }
    };
    watch(() => isEdit.value, newVal => {
      if (newVal) {
        nextTick(() => {
          var _nameInputRef$value;
          (_nameInputRef$value = nameInputRef.value) === null || _nameInputRef$value === void 0 || _nameInputRef$value.focus();
        });
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("label", null, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7FA4\u540D\u79F0")), 1), _unref(isEdit) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([!_unref(isPC) ? 'edit-h5' : ''])
      }, [_createElementVNode("main", null, [!_unref(isPC) ? (_openBlock(), _createElementBlock("header", _hoisted_2, [_createElementVNode("aside", _hoisted_3, [_createElementVNode("h1", null, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u4FEE\u6539\u7FA4\u804A\u540D\u79F0")), 1), _createElementVNode("span", null, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u4FEE\u6539\u7FA4\u804A\u540D\u79F0\u540E\uFF0C\u5C06\u5728\u7FA4\u5185\u901A\u77E5\u5176\u4ED6\u6210\u5458")), 1)]), _createElementVNode("span", {
        class: "close",
        onClick: close
      }, _toDisplayString(_unref(TUITranslateService).t("\u5173\u95ED")), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_unref(isEdit) ? _withDirectives((_openBlock(), _createElementBlock("input", {
        key: 0,
        ref_key: "nameInputRef",
        ref: nameInputRef,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(inputGroupName) ? inputGroupName.value = $event : null),
        class: "input",
        type: "text",
        onBlur: updateProfile
      }, null, 544)), [[_vModelText, _unref(inputGroupName)]]) : _createCommentVNode("", true), !_unref(isPC) ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u4EC5\u9650\u4E2D\u6587\u3001\u5B57\u6BCD\u3001\u6570\u5B57\u548C\u4E0B\u5212\u7EBF\uFF0C2-20\u4E2A\u5B57")), 1)) : _createCommentVNode("", true)]), !_unref(isPC) ? (_openBlock(), _createElementBlock("footer", _hoisted_6, [_createElementVNode("button", {
        class: "btn",
        onClick: updateProfile
      }, _toDisplayString(_unref(TUITranslateService).t("\u786E\u8BA4")), 1)])) : _createCommentVNode("", true)])], 2)) : _createCommentVNode("", true), !_unref(isEdit) || !_unref(isPC) ? (_openBlock(), _createElementBlock("p", {
        key: 1,
        onClick: close
      }, [_createElementVNode("span", null, _toDisplayString(_unref(groupProfile).name), 1), __props.isAuthor ? (_openBlock(), _createBlock(Icon, {
        key: 0,
        file: _unref(editIcon),
        width: "14px",
        height: "14px"
      }, null, 8, ["file"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
    };
  }
});